<script>
    import { _, time, date } from "../services/i18n";
    import {
        getOrders,
        notifyOrder,
        budget2order,
        orderStates,
        anulateBudget as anulateBudgetAction,
        onErrorImg,
        confirmBudget,
        unconfirmBudget
    } from "../services/orders";
    import HeaderHome from "../components/HeaderHome.svelte";
    import Icon from "../ui/Icon.svelte";
    import { mdiChevronRight } from "@mdi/js";
    import { scale, slide } from "svelte/transition";
    import { linear } from "svelte/easing";
    import { userStore, clientStore } from "../services/session";
    import ViewerButton from "../components/ViewerButton.svelte";
    import AddToCartButton from "../components/AddToCartButton.svelte";
    import { encodeOrderId, decodeOrderId } from "../../../common/orders";
    import { alert } from "../services/stores/alert";
    import { convertBudgetToShoppingCart } from "../services/shoppingCart";

    /**
     * {('order'|'budget')}
     */
    export let type = "order";

    let allOrders;

    let allQueryOrders = [
        {
            text: $_(type + "_options_filters_notSent"),
            value:
                "state=" +
                (type === "order"
                    ? `${orderStates.ORDER_DEFAULT},${orderStates.ORDER_VALIDATE},${orderStates.ORDER_IN_PROGRESS}`
                    : `${orderStates.BUDGET_DEFAULT},${orderStates.BUDGET_VALIDATE}`),
            selected: true,
        },
        {
            text: $_(type + "_options_filters_all"),
            value: "",
        },
        {
            text: $_(type + "_options_filters_100orders"),
            value: "size=100",
        },
        {
            text: $_(type + "_options_filters_30days"),
            value: "days=30",
        },
        {
            text: $_(type + "_options_filters_sentOrders"),
            value:
                "state=" +
                (type === "order"
                    ? orderStates.ORDER_SERVED
                    : orderStates.BUDGET_TRANSFORMED),
        },
    ];

    allQueryOrders.forEach((o) => {
        o.selectQuery = async (e) => {
            if (o.selected) {
                e.stopPropagation();
                return;
            }
            allOrders = await getOrders({
                typeOrder: type,
                queryOrder: o.value,
            });
            queryOptions = false;
            allQueryOrders.forEach((q) => (q.selected = false));
            o.selected = true;
            allQueryOrders = allQueryOrders;
            actualPage = 1;
        };
    });

    let query = allQueryOrders[0].value;

    clientStore.subscribe(async (client) => {
        if (client)
            allOrders = await getOrders({ typeOrder: type, queryOrder: query });
    });

    let actualPage = 1,
        pageSize = 10,
        textFilter = "";

    const DATE_OLD_2_NEW = "dateOld2New",
        DATE_NEW_2_OLD = "dateNew2Old";
    const REFERENCE_AZ = "referenceAZ",
        REFERENCE_ZA = "referenceZA";
    const PRICE_GREATEST = "priceGreatest",
        PRICE_LESS = "priceLess";
    const TITLE_STRING = "title",
        OPTION_STRING = "option";
    const orderFuncs = Object.fromEntries([
        [DATE_OLD_2_NEW, (a, b) => a.date - b.date],
        [DATE_NEW_2_OLD, (a, b) => -orderFuncs[DATE_OLD_2_NEW](a, b)],
        [REFERENCE_AZ, (a, b) => a.reference.localeCompare(b.reference)],
        [REFERENCE_ZA, (a, b) => -orderFuncs[REFERENCE_AZ](a, b)],
        [PRICE_GREATEST, (a, b) => b.totalPrice - a.totalPrice],
        [PRICE_LESS, (a, b) => -orderFuncs[PRICE_GREATEST](a, b)],
    ]);

    let orderType = DATE_NEW_2_OLD;

    $: options = [
        {
            type: TITLE_STRING,
            text: $_(type + "_options_orderBy_title"),
        },
        {
            type: OPTION_STRING,
            text: $_(type + "_options_orderBy_dateNew2Old"),
            action: () => (orderType = DATE_NEW_2_OLD),
            selected: orderType === DATE_NEW_2_OLD,
        },
        {
            type: OPTION_STRING,
            text: $_(type + "_options_orderBy_dateOld2New"),
            action: () => (orderType = DATE_OLD_2_NEW),
            selected: orderType === DATE_OLD_2_NEW,
        },
        {
            type: OPTION_STRING,
            text: $_(type + "_options_orderBy_referenceAZ"),
            action: () => (orderType = REFERENCE_AZ),
            selected: orderType === REFERENCE_AZ,
        },
        {
            type: OPTION_STRING,
            text: $_(type + "_options_orderBy_referenceZA"),
            action: () => (orderType = REFERENCE_ZA),
            selected: orderType === REFERENCE_ZA,
        },
        {
            type: OPTION_STRING,
            text: $_(type + "_options_orderBy_priceGreatest"),
            action: () => (orderType = PRICE_GREATEST),
            selected: orderType === PRICE_GREATEST,
        },
        {
            type: OPTION_STRING,
            text: $_(type + "_options_orderBy_priceLess"),
            action: () => (orderType = PRICE_LESS),
            selected: orderType === PRICE_LESS,
        },
        {
            type: TITLE_STRING,
            text: $_(type + "_options_orderPerPage"),
        },
        ...[10, 25, 50].map((n) => ({
            type: OPTION_STRING,
            text: n,
            action: () => (pageSize = n),
            selected: pageSize === n,
        })),
    ];

    const optionEvent = (opt, e) => {
        if (opt.selected) e.preventDefault();
        else {
            actualPage = 1;
            opt.action(e);
            options = options;
        }
    };

    // Cadenas de texto completas sobre las que se busca, tal y como se muestran
    // al usuario (incluyendo el sufijo :S3D del número y el nombre completo).
    const searchValues = (o) => [
        `${o.id}:S3D`,
        o.reference,
        `${o.clientName ?? ""} ${o.clientSurname1 ?? ""} ${o.clientSurname2 ?? ""}`,
        o.clientEmail,
    ];

    // Compilamos el texto buscado como expresión regular con ignore case. Si no
    // es una regex válida, escapamos el texto y buscamos de forma literal.
    $: searchRegExp = (() => {
        if (!textFilter) return null;
        try {
            return new RegExp(textFilter, "i");
        } catch {
            return new RegExp(textFilter.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i");
        }
    })();

    $: ordersFiltered = searchRegExp
        ? allOrders?.filter((o) =>
            searchValues(o).some(
                (value) => value != null && searchRegExp.test(String(value))
            )
          )
        : allOrders;

    $: ordersOrdered = ordersFiltered?.sort(orderFuncs[orderType]);

    $: ordersPage = ordersOrdered?.slice(
        (actualPage - 1) * pageSize,
        actualPage * pageSize
    );

    $: pagesOptions = Array(Math.ceil((ordersFiltered?.length ?? 0) / pageSize))
        .fill()
        .map((_a, i) => i + 1);

    let openDetails = false,
        openOptions = false,
        queryOptions = false,
        pageOptions = false;
    const closeOptions = () => {
        openOptions = false;
        queryOptions = false;
        pageOptions = false;
    };

    const classStates = (state) => {
        switch (state) {
            case orderStates.UNKNOWN:
            case orderStates.BUDGET_NULL:
            case orderStates.BUDGET_CLOSE:
            case orderStates.ORDER_NULL:
            case orderStates.ORDER_CLOSE:
                return "red";
            case orderStates.BUDGET_DEFAULT:
            case orderStates.ORDER_DEFAULT:
                return "blue-white";
            case orderStates.BUDGET_PENDING:
            case orderStates.BUDGET_VALIDATE:
            case orderStates.ORDER_VALIDATE:
            case orderStates.ORDER_IN_PROGRESS:
                return "blue";
            case orderStates.ORDER_SERVED:
            case orderStates.BUDGET_TRANSFORMED:
                return "green";
            default:
                return "red";
        }
    };

    const budgetActionsDisabled = (order) => {
        switch (order.state) {
            case orderStates.BUDGET_DEFAULT:
            case orderStates.BUDGET_VALIDATE:
                return false;
            default:
                return true;
        }
    };

    const budgetTransform = (order) =>
        order.state === orderStates.BUDGET_TRANSFORMED;
    let openDetailsStatus = false;
    $: openDetailsStatus = openDetails ? openDetailsStatus : false;
    const orderDetailsAvailable = (order) => {
        return order?.state !== orderStates.UNKNOWN && order.dateState;
    }

    const orderDetails = (order) => {
        let details = [];
        if (order.state === orderStates.UNKNOWN) return;
        const dateState = new Date(order.dateState);
        details.push({
            description: $_(`states_verbose_create`, {
                values: {
                    type: $_(`basics_${order.type}`),
                    date: $date(dateState),
                    time: $time(dateState),
                },
            }),
            complete: true,
            date: dateState,
        });

        if (order.dateValidate) {
            const dateValidate = new Date(order.dateValidate);
            details.push({
                description: $_(`states_verbose_validate`, {
                    values: {
                        type: $_(`basics_${order.type}`),
                        date: $date(dateValidate),
                        time: $time(dateValidate),
                    },
                }),
                complete: true,
                dateState: dateValidate,
            });
        }

        if (
            order.state === orderStates.ORDER_DEFAULT ||
            order.state === orderStates.ORDER_VALIDATE
        ) {
            details.push({
                description: $_(`states_verbose_notBuilding`),
                complete: false,
            });
        }

        // Estado anulado
        if (
            order.state === orderStates.BUDGET_NULL ||
            order.state === orderStates.ORDER_NULL
        ) {
            const dateAnnulled = new Date(order.dateModified);
            details.push({
                description: $_(`states_verbose_annulled`, {
                    values: {
                        type: $_(`basics_${order.type}`),
                        date: $date(dateAnnulled),
                        time: $time(dateAnnulled),
                    },
                }),
                complete: true,
                dateState: dateState,
            });
        }

        // Estado pendiente de confirmar
        if (order.state === orderStates.BUDGET_PENDING) {
            const datePending = new Date(order.dateModified);
            details.push({
                description: $_(`states_verbose_pending`, {
                    values: {
                        type: $_(`basics_${order.type}`),
                        date: $date(datePending),
                        time: $time(datePending),
                    },
                }),
                complete: true,
                dateState: datePending,
            });
        }

        // Estado cerrado
        if (
            order.state === orderStates.BUDGET_CLOSE ||
            order.state === orderStates.ORDER_CLOSE
        ) {
            const dateClose = new Date(order.dateModified);
            details.push({
                description: $_(`states_verbose_close`, {
                    values: {
                        type: $_(`basics_${order.type}`),
                        date: $date(dateClose),
                        time: $time(dateClose),
                    },
                }),
                complete: true,
                dateState: dateClose,
            });
        }

        // Estado en fabricación
        if (order.state === orderStates.ORDER_IN_PROGRESS) {
            const dateBuilding = new Date(order.dateModified);
            details.push({
                description: $_(`states_verbose_building`, {
                    values: {
                        date: $date(dateBuilding),
                        time: $time(dateBuilding),
                    },
                }),
                complete: true,
                dateState: dateBuilding,
            });

            details.push({
                description: $_("states_verbose_notSend"),
                complete: false,
            });
        }

        // Presupuesto traspasado a pedido
        if (order.state === orderStates.BUDGET_TRANSFORMED) {
            const dateTransform = new Date(order.dateTransform);
            details.push({
                description: $_(
                    order.convertedOrder
                        ? "states.verbose.traspased"
                        : "states.verbose.traspasedNot3D",
                    {
                        values: {
                            date: $date(dateTransform),
                            time: $time(dateTransform),
                            reference: `${order.convertedOrder}:S3D`,
                        },
                    }
                ),
                complete: true,
                dateState: dateTransform,
            });
        }

        // Estado servido
        if (order.state === orderStates.ORDER_SERVED) {
            const dateServed = new Date(order.dateModified);
            details.push({
                description: $_(`states_verbose_served`, {
                    values: {
                        date: $date(dateServed),
                        time: $time(dateServed),
                    },
                }),
                complete: true,
                dateState: dateServed,
            });
        }

        return details;
    };

    const transformBudget2order = async (budgetId) => {
        const responseState = await budget2order(budgetId);
        if (responseState.response.status === "OK") {
            allOrders[allOrders.findIndex((o) => o.id === budgetId)].state =
                responseState.response.state;
            allOrders = allOrders;
            convertToOrderId = null;
            openDetails = null;
        }
    };
    
    let convertToOrderId = null;
    const askTransformBudget2order = (budgetId) => {
        convertToOrderId = budgetId;
    };

    const transformBudget2orderCancel = () => {
        convertToOrderId = null;
    };
    
    let clientHeight;
    const pageSelect = (page) => async (e) => {
        e.stopPropagation();
        switch (page) {
            case "prev":
                actualPage = Math.max(actualPage - 1, 1);
                break;
            case "next":
                actualPage = Math.min(
                    actualPage + 1,
                    Math.ceil(allOrders?.length / pageSize)
                );
                break;
            default:
                actualPage = Number(page);
                break;
        }
        pageOptions = false;
        window.scrollTo(0, clientHeight);
    };

    let linksHeader = $userStore.getAcl("orderList", "budgetList")
        ? [
              {
                  name: "header_orders",
                  url: "/orders",
                  active: type === "order",
              },
              {
                  name: "header_budgets",
                  url: "/budgets",
                  active: type === "budget",
              },
          ]
        : $userStore.getAcl("orderList")
        ? [{ name: "header_orders", url: "/orders", active: type === "order" }]
        : [
              {
                  name: "header_budgets",
                  url: "/budgets",
                  active: type === "budget",
              },
          ];

    const loadToCart = (orderId) => {
        window.open(`/sim3d.html#/loadOrderCart/${orderId}`);
    };

    let convertToCartId = null;
    const convertToCart = (orderId) => {
        convertToCartId = orderId;
    }

    const convertToCartCancel = () => {
        convertToCartId = null;
    }

    const convertToCartConfirm = async () => {
        const result = await convertBudgetToShoppingCart(convertToCartId);
        convertToCartId = null;
        location.href = "/sim3d.html";
    }

    let anulateBudgetId = null;
    const anulateBudget = (orderId) => {
        anulateBudgetId = orderId;
    }

    const anulateBudgetConfirm = async () => {
        const result = await anulateBudgetAction(anulateBudgetId);
        if (result.status) {
            allOrders[allOrders.findIndex((o) => o.id === anulateBudgetId)].state =
                orderStates.BUDGET_NULL;
            allOrders = allOrders;
            anulateBudgetId = null;
        }
    };

    const anulateBudgetCancel = () => {
        anulateBudgetId = null;
    }

    function mustShowScene(order, sceneIndex) {
        // Si la última escena del pedido solo contiene elementos sin 3D, entonces estará vacía. Con esto impedimos que se muestre
        return !order.emptyMainScene || sceneIndex < order.sceneImages.length - 1 ;
    }

    const setBudgetConfirmed = async order => {
        const result = await confirmBudget(order.id);

        allOrders.some(o => {
            if (o.id === order.id) {
                o.confirmationState = result.newState;
                return true;
            }
        })
        // Recargar la lista de pedidos
        allOrders = allOrders;
        location.reload();
    }

    const setBudgetUnconfirmed = async order => {
        const result = await unconfirmBudget(order.id);

        allOrders.some(o => {
            if (o.id === order.id) {
                o.confirmationState = result.newState;
                return true;
            }
        })
        // Recargar la lista de pedidos
        allOrders = allOrders;
        location.reload();
    }

    let confirmedFilter = false;

    const getReportUrl = (order) => {
        if (budgetTransform(order) && order.convertedOrder) {
            return `#/order/${ encodeOrderId(order.convertedOrder) }`;
        }
        else {
            return `#/order/${ encodeOrderId(order.id) }`;
        }
    }
</script>

<svelte:body on:click={closeOptions} />

<HeaderHome links={linksHeader} />

<div class="search">
    <div>
        <div class="search-container">
            <img src="/icons/search-sim3d.svg" alt="search-icon" />
            <input
                type="text"
                placeholder={$_(type + "_search_input")}
                bind:value={textFilter}
                on:input={() => (actualPage = 1)}
            />
        </div>
    </div>
    {#if type === "budget"}
        <div>
            <label>
                <input type="checkbox" id="showConfirmedOnly" bind:checked={confirmedFilter}/>
                {$_("budget_table_showConfirmedOnly")}
            </label>
        </div>
    {/if}
    <div>
        <div class="query-select">
            <span
                on:keypress={(e) => {
                    if (queryOptions) {
                        queryOptions = false;
                        return;
                    }
                    closeOptions();
                    queryOptions = true;
                    e.stopPropagation();
                }}

                on:click={(e) => {
                    if (queryOptions) {
                        queryOptions = false;
                        return;
                    }
                    closeOptions();
                    queryOptions = true;
                    e.stopPropagation();
                }}
                id="filter-pc"
                >{$_(`order_options_filters_filter`)}
                {allQueryOrders.find((q) => q.selected).text}
                <img
                    class="img-options"
                    id="arrow-desp"
                    src="/icons/arrow-left-azul4.svg"
                    alt="search-icon"
                /></span
            >
            <span
                on:keypress={(e) => {
                    if (queryOptions) {
                        queryOptions = false;
                        return;
                    }
                    closeOptions();
                    queryOptions = true;
                    e.stopPropagation();
                }}
                on:click={(e) => {
                    if (queryOptions) {
                        queryOptions = false;
                        return;
                    }
                    closeOptions();
                    queryOptions = true;
                    e.stopPropagation();
                }}
                id="filter-mobile"
                >{allQueryOrders.find((q) => q.selected).text}
                <img
                    class="img-options"
                    id="arrow-desp"
                    src="/icons/arrow-left-azul4.svg"
                    alt="search-icon"
                /></span
            >
            <!--<span class:open={queryOptions} on:click={e => { if(queryOptions) {queryOptions = false; return} closeOptions(); queryOptions = true; e.stopPropagation() }}>{allQueryOrders.find(q => q.selected).text}</span>-->
            {#if queryOptions}
                <ul transition:slide={{ duration: 200 }}>
                    {#each allQueryOrders as queryOrder}
                        {#if !queryOrder.selected}
                            <li on:click={queryOrder.selectQuery} on:keypress={queryOrder.selectQuery}>
                                {queryOrder.text}
                            </li>
                        {/if}
                    {/each}
                </ul>
            {/if}
        </div>
        <img
            class="img-options"
            on:click={(e) => {
                if (openOptions) {
                    openOptions = false;
                    return;
                }
                closeOptions();
                openOptions = true;
                e.stopPropagation();
            }}
            on:keypress={(e) => {
                if (openOptions) {
                    openOptions = false;
                    return;
                }
                closeOptions();
                openOptions = true;
                e.stopPropagation();
            }}
            src="/icons/arrow-down-up.svg"
            alt="search-icon"
        />
        {#if openOptions}
            <div
                on:click={(e) => e.stopPropagation()}
                on:keypress={(e) => e.stopPropagation()}
                class="orders-options"
                in:scale={{ duration: 200 }}
                out:scale={{ duration: 300 }}
            >
                <div id="triangle-options" />
                <dl class="options">
                    {#each options as option (option.text)}
                        {#if option.type === TITLE_STRING}
                            <dt>{option.text}</dt>
                        {:else if option.type === OPTION_STRING}
                            <dd
                                class:selected-option={option.selected}
                                on:keypress={(e) => optionEvent(option, e)}
                                on:click={(e) => optionEvent(option, e)} >
                                {option.text}
                            </dd>
                        {/if}
                    {/each}
                </dl>
            </div>
        {/if}
    </div>
</div>

{#if allOrders}
    <ul id="orders-list" style="padding: 0">
        {#each ordersPage as order (order.id)}
            {#if !confirmedFilter || order.confirmationState === 1}
            <li class="order {classStates(order.state)}">
                <article class="data">
                    <section class="date-id">
                        <span class="date" id="date-pc">
                            {$date(new Date(order.date)) +
                                ", " +
                                $time(new Date(order.date))}
                        </span>
                        <span class="date" id="date-mobile">
                            {$date(new Date(order.date))}
                        </span>
                        <span class="id">
                            {$_(type + "_table_idOrder")}:
                            <strong>{order.id}:S3D</strong>
                        </span>
                        <span class="client-name">
                            {$_(type + "_table_clientName")}:
                            <strong>{order.clientName} {order.clientSurname1} {order.clientSurname2}</strong>
                        </span>
                        {#if order.totalItems}
                            <span class="articles-number">
                                {$_(type + "_table_articles")}: {order.totalItems}
                            </span>
                        {/if}
                        {#if order.confirmationState === 1}
                            <span class="budget-confirmed">{$_("budget_table_budgetConfirmed")}</span>
                        {/if}
                    </section>
                    <section class="images">
                        {#each order.sceneImages as image, i}
                            {#if mustShowScene(order, i)}
                                <div class="order-scene-item">
                                    <AddToCartButton
                                        sceneId={i}
                                        orderId={order.id}
                                    />
                                    <ViewerButton
                                        sceneId={i}
                                        orderId={order.id}
                                        optionalText={$_("order_options_orderBy_open3dViewer")}
                                        styleVariant="small"
                                    />
                                    <img
                                        src={image}
                                        alt="escena"
                                        on:error={onErrorImg("model")}
                                    />
                                </div>
                            {/if}
                        {/each}
                    </section>
                    <section class="state-ref">
                        <span class={classStates(order.state)}>
                            {order.state != null
                                ? $_("states_" + order.state)
                                : $_(type + "_table_stateless")}
                        </span>
                        <span>REF: {order.reference}</span>
                        <span class="mobile-data">
                            {$_(type + "_table_total")}
                        </span>
                        <strong class="mobile-data">
                            {@html order.getTotalPrice(order)}
                        </strong>
                        
                        <a  class="btn-3d third"
                            href={getReportUrl(order)}
                            rel="noreferrer"
                            target="_blank"
                            id="details-btn-mobile">

                            { budgetTransform(order) && order.convertedOrder ? 
                                $_(type + "_table_details_seeInformOrder") : 
                                $_(type + "_table_details_seeInform")
                            }
                           
                        </a>
                        
                        <button
                            class="btn-3d third"
                            class:third-active={openDetails === order.id}
                            disabled={order.state === orderStates.UNKNOWN}
                            on:click={() =>
                                (openDetails =
                                    order.id === openDetails
                                        ? false
                                        : order.id)}
                            id="details-btn-mobile">
                            {$_(type + "_table_seeDetails")}
                        </button>
                    </section>
                    <section class="price">
                        <span>{$_(type + "_table_total")}</span>
                        <strong>
                            {@html order.getTotalPrice(order)}
                        </strong>

                        <div class="actions">
                            <a  class="btn-3d third"
                                href={getReportUrl(order)}
                                rel="noreferrer"
                                target="_blank">

                                { budgetTransform(order) && order.convertedOrder ? 
                                    $_(type + "_table_details_seeInformOrder") : 
                                    $_(type + "_table_details_seeInform")
                                }
                            </a>

                            <button
                                class="btn-3d third"
                                class:third-active={openDetails === order.id}
                                disabled={order.state === orderStates.UNKNOWN}
                                on:click={() =>
                                    (openDetails =
                                        order.id === openDetails
                                            ? false
                                            : order.id)}
                                id="btn-show-details">
                                {$_(type + "_table_seeDetails")}
                            </button>
                        </div>
                    </section>
                </article>
                {#if openDetails === order.id && convertToCartId === null && convertToOrderId === null }
                    <article
                        class="details"
                        class:states-open={openDetailsStatus === order.id}
                        in:slide={{ duration: 200 }}
                        out:slide={{ easing: linear, duration: 200 }}>

                        {#if orderDetailsAvailable(order)}
                            <button
                                class="btn-3d third"
                                on:click={() =>
                                    (openDetailsStatus =
                                        order.id === openDetailsStatus
                                            ? false
                                            : order.id)}>
                                {$_(type + "_table_details_orderState")}
                            </button>
                        {/if}

                        {#if type === "budget" && order.confirmationState === 0}
                            <button 
                                class="btn-3d third"
                                disabled={budgetActionsDisabled(order)}
                                on:click={setBudgetConfirmed(order)}>
                                {$_("budget_table_details_confirmBudget")}
                            </button>
                        {:else if type === "budget" }
                            <button 
                                class="btn-3d third"
                                disabled={budgetActionsDisabled(order)}
                                on:click={setBudgetUnconfirmed(order)}>
                                {$_("budget_table_details_unconfirmBudget")}
                            </button>
                        {/if}

                        {#if type === "order"}
                            <!--<button class="btn-3d second">{$_(type+'.table.details.incidence')}</button>-->
                        {:else if type === "budget" && $userStore.getAcl("orderConfirmation")}
                            <button
                                disabled={budgetActionsDisabled(order)}
                                class="btn-3d warning"
                                on:click={() => askTransformBudget2order(order.id)}>
                                {$_(type + "_table_details_toOrder")}
                            </button>
                        {/if}

                        <!-- Cargar al carrito: disponible para todos los perfiles -->
                        {#if type === "budget" && convertToCartId === null}
                            <button
                                disabled={budgetActionsDisabled(order)}
                                class="btn-3d warning"
                                on:click={() => convertToCart(order.id)}>
                                {$_("budget_loadCart_buttonTitle")}
                            </button>
                        {/if}

                        {#if budgetTransform(order) && order.convertedOrder}
                            &nbsp;
                        {:else}
                            {#if type === "budget"}
                                <button
                                    class="btn-3d danger"
                                    disabled={budgetActionsDisabled(order)}
                                    on:click={() => anulateBudget(order.id)}>
                                    {$_(type + "_table_details_anulate")}
                                </button>
                            {/if}
                        {/if}
                    </article>
                {/if}

                <!-- Confirmación de convertir en pedido -->
                {#if convertToOrderId === order.id}
                    <article class="order-action-confirmatin" transition:slide>
                        <header>
                            <p>{$_("budget_convert2Order_warningMessage")}</p>
                        </header>
                        <button
                            class="btn-3d third"
                            on:click={() => transformBudget2orderCancel()}>
                            {$_("budget_convert2Order_cancel")}
                        </button>
                        <button
                            class="btn-3d warning"
                            on:click={() => transformBudget2order(order.id)}>
                            {$_("budget_convert2Order_confirm")}
                        </button>
                    </article>
                {/if}

                <!-- Confirmación de cargar carrito -->
                {#if convertToCartId === order.id}
                    <article class="order-action-confirmation" transition:slide>
                        <header>
                            <p>{$_("budget_loadCart_warningMessage")}</p>
                        </header>
                        <button
                            class="btn-3d third"
                            on:click={() => convertToCartCancel()}>
                            {$_("budget_loadCart_cancel")}
                        </button>
                        <button
                            class="btn-3d warning"
                            on:click={() => convertToCartConfirm()}>
                            {$_("budget_loadCart_confirm")}
                        </button>
                    </article>
                {/if}

                <!-- Confirmación de anular presupuesto -->
                {#if anulateBudgetId === order.id}
                    <article class="order-action-confirmation" transition:slide>
                        <header>
                            <p>{$_("budget_anulateBudget_warningMessage")}</p>
                        </header>
                        <button
                            class="btn-3d third"
                            on:click={() => anulateBudgetCancel()}>
                            {$_("budget_anulateBudget_cancel")}
                        </button>
                        <button
                            class="btn-3d danger"
                            on:click={() => anulateBudgetConfirm()}>
                            {$_("budget_anulateBudget_confirm")}
                        </button>
                    </article>
                {/if}

                {#if openDetailsStatus === order.id && openDetails === order.id}
                    <article class="article-states" transition:slide>
                        <ul class="states">
                            {#each orderDetails(order) as detail}
                                <li transition:scale>
                                    <div
                                        class="circle-state"
                                        class:completed={detail.complete}
                                    />
                                    <span>{detail.description}</span>
                                </li>
                            {/each}
                        </ul>
                    </article>
                {/if}
            </li>
            <!-- if !confirmedFilter || order.confirmationState === 1 -->
            {/if}
        {:else}
            <h4 class="not-found">
                {$_(type + "_table_ordersNotFound")}
            </h4>
        {/each}
    </ul>
{/if}

{#if allOrders && ordersPage.length > 0}
    <div class="pagination-select">
        <button on:click={pageSelect("prev")}>
            <Icon
                rotate="180"
                path={mdiChevronRight}
                color="var(--left-page-color)"
                class="left-page"
                style="fill:#1b3258; stroke: transparent;"
            />
        </button>
        <button
            class:active-selector={pageOptions}
            class:various-pages={pagesOptions.length > 1}
            class="page-selector"
            on:click={(e) => {
                if (pageOptions || pagesOptions.length === 1) {
                    pageOptions = false;
                    return;
                }
                closeOptions();
                pageOptions = true;
                e.stopPropagation();
            }}
        >
            {actualPage}
        </button>
        <button on:click={pageSelect("next")}>
            <Icon
                path={mdiChevronRight}
                color="var(--right-page-color)"
                class="right-page"
                style="fill:#1b3258; stroke: transparent;"
            />
        </button>
        {#if pageOptions}
            <ul in:slide={{ duration: 200 }} out:slide={{ duration: 300 }}>
                {#each pagesOptions as pageOpt}
                    {#if pageOpt !== actualPage}
                        <li on:click={pageSelect(pageOpt)} on:keypress={pageSelect(pageOpt)}>
                            {pageOpt}
                        </li>
                    {/if}
                {/each}
            </ul>
        {/if}
    </div>
{/if}
<svelte:head>
    <link rel="stylesheet" href="/styles/pages/orders.css" />
    <!--
<script src="https://unpkg.com/jspdf@latest/dist/jspdf.umd.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js" integrity="sha512-BNaRQnYJYiPSqHHDb58B0yaPfCu+Wgds8Gp/gU33kqBtgNS4tSPHuGibyoeqMV/TJlSKda6FXzoEyYGjTe+vXA==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
-->
</svelte:head>

<style>
    .price > div.actions {
        display: flex;
        flex-direction: column;
        gap: 13px;
        margin-top: 16px;
    }
</style>
